<template>
	<!-- 活动指南 -->
	<el-row id="ActivityOperationsGuide" type="flex" justify="end">
		<el-col class="loginBox">
			<div>
				<el-button size="small" @click="submitForm">下载</el-button>
			</div>
			<div class="imgBox">
				<img src="../pic/guide.jpg" />
			</div>
		</el-col>
	</el-row>
</template>
<!--数据存贮交互，事件控制地区-->
<script>
	export default {
		name: 'ActivityOperationsGuide',
		data() {
			return {
			}
		},
		methods: {
			submitForm: function() {
				window.location.href=this.httpUrl+"HXXCStadiumPCService/stadium/downOperationGuide";
			}
		}
	}
</script>

<style scoped>
	#ActivityOperationsGuide {
		width: 100%;
		height: 620px;
		background-size: 100% 100%;
	}
	.loginBox {
		background: #fff;
		max-height: 400px;
		border-radius: 4px;
		position: relative;
	}
	.imgBox {
		margin-top: 20px;
		height: 580px;
		overflow-y: scroll;
	}
	.imgBox img {
		width: 100%;
	}
	.demo-ruleForm {
		width: 100%;
	}
	.el-input__icon {
		position: absolute;
		right: 5px;
		top: 0;
	}
	.fontMes {
		width: 100%;
		text-align: right;
		color: #B7A575;
		font-size: 8px;
		margin-top: -11px;
		margin-bottom: 11px;
	}
	.title {
		color: #000000;
		font-weight: bold;
		font-size: 24px;
		margin-bottom: 29px;
		text-align: center;
	}
	.titleIcon {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/views/ActivityOperationsGuide.vue